import {ProtectedUserRoute, ProtectedRoute, ProtectedSupplierRoute, ProtectedAdminRoute, ProtectedShipperRoute} from "./ProtectedRoute";

import React , { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate, useNavigate, useLocation } from 'react-router-dom';
import HomePage from './pages/HomePage';
import ProductDetails from './pages/ProductDetails';
import ProductViewReview from './pages/ProductViewReview';

import ContactUs from './pages/ContactUs';

import useScrollToHash from './components/useScrollToHash';
import Cart from './pages/Cart';
import Checkout from './pages/Checkout';
import PaymentResult from './pages/PaymentResult';

import CartView from './components/CartView';
import TermsAndConditions from './components/TermsAndConditions';
import PrivacyPolicy from './components/PrivacyPolicy';
import ShippingPolicy from './pages/ShippingPolicy';
import ReturnRefundPolicy from './pages/ReturnRefundPolicy'; 
import FAQComponent from './pages/FAQComponent';
import Payment from './pages/Payment';
import ThankYou from './pages/ThankYou';
import OrderHistory from './pages/OrderHistory';
import DeliverySlotSelector from './pages/DeliverySlotSelector';

import AboutUs from './pages/AboutUs';

import Login from './auth/Login';
import axios from 'axios';  
import ForgotPassword from './auth/ForgotPassword';
import ResetPassword from './auth/ResetPassword';
import UserDetails from './auth/UserDetails';
import UserDashboard from './auth/UserDashboard';
import SupplierDetails from './auth/SupplierDetails';
import SupplierDashboard from './auth/SupplierDashboard';
import SupplierStepper from './auth/SupplierStepper';
import SupplierVerifyProduct from './auth/SupplierVerifyProduct';
import SupplierAddProduct from './auth/SupplierAddProduct';

import ProfilePage from './auth/ProfilePage';
import RefundForm from './pages/RefundForm';
import MyReferrals from './pages/MyReferrals';

import { useAuth , AuthProvider  } from './context/AuthContext';
import SupplierLogin from './auth/SupplierLogin';

import AdminLogin from './admin/AdminLogin';
import AdminDashboard from './admin/AdminDashboard';

import ShipperLogin from './shipper/ShipperLogin';
import ShipperDashboard from './shipper/ShipperDashboard';
import ShipperDetails from './shipper/ShipperDetails';

const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0); // Scroll to top when the pathname changes
  }, [pathname]);

  return null;
};
const AppContent = () => {
  const [cart, setCart] = useState([]);
  const navigate = useNavigate();
  const { user, userSupplier, logoutSupplier, logout, setUser, setUserSupplier } = useAuth();

  const handleLoginSuccess = (userData) => setUser(userData);
  const handleLoginSupplierSuccess = (userData) => setUserSupplier(userData);

  
  
  useEffect(() => {
    axios.interceptors.request.use(
      (config) => {
        const token = localStorage.getItem("token");
        if (token) {
          config.headers.Authorization = `Bearer ${token}`;
        }
        return config;
      },
      (error) => Promise.reject(error)
    );
  }, []);

  return (
    <>

      {!userSupplier && !(user && user.roles && user.roles[0] && user.roles[0].role === "ROLE_ADMIN") && !(user && user.roles && user.roles[0] && user.roles[0].role === "ROLE_SHIPPER") && <CartView />}
<ScrollToTop />
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/product/:productId" element={<ProductViewReview />} />
        <Route path="/contact-us" element={<ContactUs />} />
        <Route path="/login" element={<Login onLoginSuccess={handleLoginSuccess} />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/reset-password" element={<ResetPassword />} />
        <Route path="/supplierlogin" element={<SupplierLogin onLoginSuccess={handleLoginSupplierSuccess} />} />
        <Route path="/terms" element={<TermsAndConditions />} />
        <Route path="/privacypolicy" element={<PrivacyPolicy />} />
          <Route path="/refund" element={<ReturnRefundPolicy />} /> 
         <Route path="/faq" element={<FAQComponent />} />     
          <Route path="/shipping" element={<ShippingPolicy />} />    
            <Route path="/adminlogin" element={<AdminLogin onLoginSuccess={handleLoginSuccess} />} />
      <Route path="/shipperlogin" element={<ShipperLogin onLoginSuccess={handleLoginSuccess} />} />    
      <Route path="/aboutus" element={<AboutUs />} />   
            
        {/* Protected User Routes */}
        <Route
          path="/profile"
          element={
            <ProtectedRoute user={user} redirectPath="/login">
             <ProfilePage /> 
            </ProtectedRoute>
          }
        />

        <Route
          path="/orders"
          element={
            <ProtectedRoute user={user} redirectPath="/login">
             <OrderHistory /> 
            </ProtectedRoute>
          }
        />

        <Route
          path="/referral"
          element={
            <ProtectedRoute user={user} redirectPath="/login">
             <MyReferrals /> 
            </ProtectedRoute>
          }
        />

        <Route
          path="/refunds"
          element={
            <ProtectedRoute user={user} redirectPath="/login">
             <RefundForm /> 
            </ProtectedRoute>
          }
        />


        <Route
          path="/thank-you"
          element={
            <ProtectedRoute user={user} redirectPath="/login">
             <ThankYou />
            </ProtectedRoute>
          }
        />
        <Route
          path="/payment"
          element={
            <ProtectedRoute user={user} redirectPath="/login">
             <Payment />
            </ProtectedRoute>
          }
        />

       <Route
          path="/paymentresult"
          element={
            <ProtectedRoute user={user} redirectPath="/login">
             <PaymentResult />
            </ProtectedRoute>
          }
        />

        <Route
          path="/checkout"
          element={
            <ProtectedRoute user={user} redirectPath="/login">
              <Checkout />
            </ProtectedRoute>
          }
        />
        <Route
          path="/delivery-slots"
          element={
            <ProtectedRoute user={user} redirectPath="/login">
              <DeliverySlotSelector />
            </ProtectedRoute>
          }
        />

        <Route
          path="/dashboard"
          element={
            <ProtectedRoute user={user} redirectPath="/login">
              <UserDashboard />
            </ProtectedRoute>
          }
        />
        <Route
          path="/user-details"
          element={
            <ProtectedUserRoute user={user} redirectPath="/login">
              <UserDetails />
            </ProtectedUserRoute>
          }
        />

        <Route
          path="/cart"
          element={
            <ProtectedRoute user={user} redirectPath="/login">
              <Cart />
            </ProtectedRoute>
          }
        />


        {/* Protected Supplier Routes */}
        <Route
          path="/supplierdashboard"
          element={
            <ProtectedSupplierRoute user={userSupplier} redirectPath="/supplierlogin">
              <SupplierDashboard />
            </ProtectedSupplierRoute>
          }
        />
        <Route
          path="/supplier-details"
          element={
            <ProtectedSupplierRoute user={userSupplier} redirectPath="/supplierlogin">
              <SupplierDetails />
            </ProtectedSupplierRoute>
          }
        />
        <Route
          path="/suppliers"
          element={
            <ProtectedSupplierRoute user={userSupplier} redirectPath="/supplierlogin">
              <SupplierStepper />
            </ProtectedSupplierRoute>
          }
        />
      
      
              <Route
          path="/supplier-verify-products"
          element={
            <ProtectedSupplierRoute user={userSupplier} redirectPath="/supplierlogin">
              <SupplierVerifyProduct />
            </ProtectedSupplierRoute>
          }
        />
      
        <Route
          path="/supplier-add-product"
          element={
            <ProtectedSupplierRoute user={userSupplier} redirectPath="/supplierlogin">
              <SupplierAddProduct />
            </ProtectedSupplierRoute>
          }
        />

      {/* admin */ }
        <Route
          path="/admindashboard"
          element={
            <ProtectedAdminRoute user={user} redirectPath="/adminlogin">
             <AdminDashboard /> 
            </ProtectedAdminRoute>
          }
        />


  {/* shipper */ }
        <Route
          path="/shipperdashboard"
          element={
            <ProtectedShipperRoute user={user} redirectPath="/shipperlogin">
             <ShipperDashboard /> 
            </ProtectedShipperRoute>
          }
        />
     <Route
          path="/shipper-details"
          element={
            <ProtectedUserRoute user={user} redirectPath="/shipperlogin">
              <ShipperDetails />
            </ProtectedUserRoute>
          }
        />


        {/* Fallback Route */}
        <Route path="*" element={<Navigate to="/" />} />
      </Routes>
</>
  );
};
export default AppContent;